import { Table, TableCell, TableContainer, TableHead } from '@mui/material'
import React, { ReactElement } from 'react'
import globalStyles from "../../../assets/styles/global.module.scss"; 
import style from "../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss";

interface CarouselTemplateVariableTableProps {
    tableBodyContent: ReactElement,
    templateType: string,
    variableType?: string,
} 

const TemplateVariableTable: React.FC<CarouselTemplateVariableTableProps> = (props) => {
    
    const { tableBodyContent, templateType, variableType } = props;

    const getValueOfSecondTableCell = () => {
        if(templateType.toLowerCase() == "carousel"){
            if(variableType?.toLowerCase() == "globalheader") return "Value";
            return "Fallback Value";
        } else {
            if(variableType?.toLowerCase() == "header") return "Take value from Contact Detail";
            return "Value";
        }
    }

    return (
        <>
            <TableContainer className={`${globalStyles.boxSizingBorderBox} ${globalStyles.maxWidthFull} ${globalStyles.fullwidth} ${globalStyles.overflowAuto}`}>
                <Table>
                    <TableHead>
                        <TableCell className={style.tableHeadingFontStyle}></TableCell>
                        <TableCell className={style.tableHeadingFontStyle}> 
                            {getValueOfSecondTableCell()}
                        </TableCell>
                        {(templateType == "basic" || (templateType == "carousel" && variableType?.toLowerCase() == "globalheader")) && 
                            <TableCell className={style.tableHeadingFontStyle}> {variableType == "header" ? "Backup / Static Value" : "Fallback Value"} </TableCell>
                        }
                    </TableHead>
                    {tableBodyContent}
                </Table>
            </TableContainer>
        </>
    )
}

export default TemplateVariableTable
